import { Document } from '../../jurisdiction/jurisdiction.domain';
import { IEnergyProducerUnit } from './interfaces/energyProducerUnit';
import { GridApplicationDocumentTypes } from './enums/grid-application-document-types.enum';

export class ElectricalGenerator implements IEnergyProducerUnit {
  constructor() {
    this.documents = [];
    this.documents.push(new Document(GridApplicationDocumentTypes.EnergyUnitDataSheet));
    this.documents.push(new Document(GridApplicationDocumentTypes.UnitCertificate));
  }

  id: number;
  manufacturer: string;
  type: string;
  identical_units: number;
  max_unit_power: number;
  documents: Document[];
}
